import template from './kform-builder-option-path.html';
import controller from './kform-builder-option-path.controller';

/**
 * A directive for a field to edit a component's key.
 *
 * @returns {*} Directive
 */
const kformBuilderOptionPathDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionPathDirective;
